import { AfterViewInit, ChangeDetectorRef, Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DropdownComponent, DropdownOption } from '../shared/component/dropdown/dropdown.component';
import { AuthService, Default_SessionUserDetails, SessionData_Response } from '../core/services/auth.service';
import { CoreService } from '../core/services/core.service';
import { PageTitleService } from '../core/services/page-title.service';
import { MatIcon } from '@angular/material/icon';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { DrawerService } from '../shared/services/drawer.service';
import { PageLayoutService } from '../shared/services/page-layout.service';
import { SafeHtmlPipe } from '../shared/pipes/safeHtml.pipe';
import { QuickSearchComponent } from '../shared/component/quick-search/quick-search.component';

@Component({
  selector: 'eap-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DropdownComponent, MatSidenavModule, SafeHtmlPipe, QuickSearchComponent, MatIcon],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  providers: [PageTitleService, PageLayoutService]
})
export class LayoutComponent implements AfterViewInit {

  @ViewChild('drawer') drawer!: MatDrawer;
  drawerContent: TemplateRef<any> | null = null;
  public currentUser: SessionData_Response = Default_SessionUserDetails;

  isAuthPage = false;
  pages: DropdownOption[] = [];
  isReferralInfoActive: boolean = false;

  @Input() pageName: string = "Agency Portal"; //todo name is temperory
  currentSession$ = this.authService.currentSession$;
  systemValues$ = this.coreService.refereshSystemValues();
  pageTitle: string[] = [];
  public isHomeButtonShown: boolean = false; // Flag to show hide home button
  public isDrawerOpen: boolean = false; // Flag to manage drawer state
  public readonly navigationBreadCrumbs = new Map<string, string>([
    ['Agency Portal', '/agency-home'],
    ['DSN Master', '/officers/list']
  ]);

  constructor(
    private router: Router,
    private authService: AuthService,
    private coreService: CoreService,
    private cdRef: ChangeDetectorRef,
    private pageTitleService: PageTitleService,
    private drawerService: DrawerService,
    private pageLayoutService: PageLayoutService,
  ) {
    this.router.events.subscribe(e => {
      this.isAuthPage = this.router.url.includes('/auth'); //TODO
      if (e instanceof NavigationEnd) { // TO apply card effect for referral info.
        this.isReferralInfoActive = e.url.includes('referral-info');
      }
    });
      this.authService.currentSession$.subscribe((res) => {
        this.currentUser = res;
        this.getDsnSequence();
      });
  }

 private trySetNavbarHeight(attempts = 0) {
  const header = document.querySelector('.header') as HTMLElement;
  
  // If header is found and has height, set it and stop
  if (header && header.offsetHeight > 0) {
    this.pageLayoutService.setNavbarHeight(header.offsetHeight);
    return;
  }

  // Safety break: Stop trying after 10 attempts (approx 1 second)
  if (attempts > 10) {
    console.warn("[Directive] [Layout] Navbar height could not be determined.");
    return;
  }

  // If not found or height is 0, wait 100ms and try again
  setTimeout(() => {
    this.trySetNavbarHeight(attempts + 1);
    console.log("[Directive] [Layout] attempt", attempts + 1);
  }, 100);
}
  
  ngOnInit() {
    this.coreService.loadBuildVersion().subscribe(response => {
      if (response) {
        console.log('**************************************************************************');
        console.log('External App Version:', response.version || "");
        console.log('External App CommitId:', response.commitNumber || "");
        console.log('**************************************************************************');
      }
    })
    this.pageTitleService.pageTitle$.subscribe((parts: string[]) => {
      this.pageTitle = parts;
      this.cdRef.detectChanges();
      requestAnimationFrame(() => this.showHomeButton());
    });

    // Subscribe to drawer toggle events
    this.drawerService.drawerToggle$.subscribe(isOpen => {
      if (isOpen) {
        this.drawer.open();
      } else {
        this.drawer.close();
      }
    });

    // Subscribe to drawer content changes
    this.drawerService.drawerContent$.subscribe(content => {
      this.drawerContent = content;
    });
  }


  ngAfterViewInit() {
    this.trySetNavbarHeight();
  }

  onBreadcrumbClick(index: number): void {
    // Define routing behavior for each level
    const label = this.pageTitle[index];
    const route = this.navigationBreadCrumbs.get(label);


    if (route) {
      this.router.navigate([route]);
    }
  }

  // Open the drawer
  openDrawer() {
    this.isDrawerOpen = true;
  }

  // Close the drawer
  closeDrawer() {
    this.isDrawerOpen = false;
  }

  private getDsnSequence() {
    if (this.currentUser.DsnSequence) {

      this.pages = [
        { label: 'My Court Dates', route: '/court-list/DSN/' + this.currentUser.DsnSequence, icon: 'calendar_month' },
        { label: 'Log Out', route: '/login', icon: 'logout' },
      ];

      if(this.currentUser.AllowPoliceMaintenance) {
        this.pages.unshift({ label: 'Officer Maintenance', route: '/officers', icon: 'manage_accounts' });
      }

    }
  }

  /**
   * This method is used when home button is clicked.
   */
  onClickHome() {
    this.router.navigate(['agency-home']);
  }

  /**
   * This method is used to show hide home button.
   * @returns 
   */
  showHomeButton() {
    if (this.pageTitle && this.pageTitle.length > 1) {
      this.isHomeButtonShown = true;
      return;
    } else {
      this.isHomeButtonShown = false;
    }
  }
}

